import React from 'react';

import { Layout } from 'antd';
import classnames from 'classnames';
import { NextPage } from 'next';
import { connect } from 'react-redux';
import AccountLateralMenuConsumer from 'src/components/menu/AccountLateralMenuConsumer';
import { IRootReducers } from 'src/reducers';

const { Content, Sider } = Layout;

type Props = ReturnType<typeof mapStateToProps> & OwnProps;
interface OwnProps {
  customClassName: string;
  children: React.ReactNode;
  hideDesktopMenu?: boolean;
}

const UserProfile: NextPage<Props, {}> = ({
  children,
  customClassName,
  impersonate,
  hideDesktopMenu = false,
}) => {
  const lateralMenuClassnames: string = classnames(
    'account-menu',
    'account-menu__only-desktop',
    'account-menu-con',
  );

  const lateralMenu = hideDesktopMenu ? null : (
    <Sider width={396} className={lateralMenuClassnames} theme="light">
      <AccountLateralMenuConsumer />
    </Sider>
  );

  const layoutClassnames: string = classnames(
    customClassName,
    'container',
    'user-profile-layout',
    'user-profile-layout-con',
    {
      'user-profile-layout__impersonate': impersonate,
    },
  );

  return (
    <Layout className={layoutClassnames}>
      {lateralMenu}
      <Content className={ hideDesktopMenu ? '' : 'content-page' }>        
        {children}
      </Content>
    </Layout>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    impersonate: state.auth.impersonate,
  };
};

export default connect(mapStateToProps, null)(UserProfile);
